<template>
  <a-skeleton :loading="loading" :paragraph="{ rows: 6 }">
    <div>
      <a-alert type="warning">
        <div slot="message">
          Note: Code is not duplicate / Mã không trùng lặp
        </div>
      </a-alert>

      <a-form-model
        :model="form"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        style="margin-top: 10px;"
        :rules="rules"
        ref="ruleForm"
      >
        <a-form-model-item label="Code / Mã" prop="code">
          <a-input v-model="form.code" placeholder="Enter code..." />
        </a-form-model-item>
        <a-form-model-item label="Title / Tên loại nghỉ phép" prop="title">
          <a-input v-model="form.title" placeholder="Enter title..." />
        </a-form-model-item>
        <a-form-model-item label="Benefit / Chế độ" prop="benefit">
          <a-select v-model="form.benefit" placeholder="Select benefit">
            <a-select-option v-for="i in typeBenefits" :key="i.id">
              {{ i.title }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="Order Number / Vị trí sắp xếp">
          <a-input-number
            v-model="form.orderNumber"
            placeholder="Enter number..."
            type="number"
            :formatter="
              (value) =>
                isInt(value)
                  ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  : undefined
            "
            :parser="(value) => parseInt(value)"
            style="width: 100%;"
          />
        </a-form-model-item>

        <a-form-model-item label="With paid / Tính lương ?">
          <a-switch
            size="small"
            @change="onChangeAddAttendanceSheet"
            :defaultChecked="checkAddAttendanceSheet"
          />
        </a-form-model-item>
        <a-form-model-item
          label="Allow replace leave on Holiday/Weekends / Cho phép thay thế nghỉ phép vào ngày lễ/cuối tuần ?"
        >
          <a-switch
            size="small"
            @change="onChangeAllowReplaceLeaveOnHoliday"
            :defaultChecked="form.allowReplaceLeaveOnHoliday"
          />
        </a-form-model-item>
        <a-form-model-item label="Description / Mô tả">
          <VueEditor
            class="ict24h-editor"
            :editor-toolbar="customToolbar"
            placeholder="Enter description..."
            v-model="form.description"
          />
        </a-form-model-item>
      </a-form-model>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }"
      >
        <a-popconfirm
          title="Confirm action?"
          ok-text="Delete"
          cancel-text="Cancel"
          @confirm="onDeletedTypeWorkLeave"
        >
          <a-button
            icon="delete"
            type="danger"
            style="float: left;"
            :loading="loadingBtn"
          >
            Delete
          </a-button>
        </a-popconfirm>

        <a-button style="margin-right: 10px;" icon="close" @click="close">
          Close
        </a-button>
        <a-button
          type="primary"
          @click="onSubmit"
          icon="edit"
          :loading="loadingBtn"
        >
          Update
        </a-button>
      </div>
    </div>
  </a-skeleton>
</template>
<script>
import { typeBenefits } from "../constant/default";
import query from "../constant/query";

function isInt(value) {
  return (
    !isNaN(value) &&
    parseInt(Number(value)) == value &&
    !isNaN(parseInt(value, 10))
  );
}

const rules = {
  code: [{ required: true, message: "Required / Mã không được bỏ trống" }],
  title: [
    {
      required: true,
      message: "Required / Loại nghỉ phép không được bỏ trống",
    },
  ],
  benefit: [
    { required: true, message: "Required / Chế độ không được bỏ trống" },
  ],
};

const defaultForm = {
  addAttendanceSheet: false,
};

export default {
  props: {
    close: { type: Function, required: true },
    refreshAfterUpdated: { type: Function, required: true },
    refreshAfterDeleted: { type: Function, required: true },
    idTypeWorkLeave: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      typeBenefits,
      rules,
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      checkAddAttendanceSheet: false,
      form: {
        ...defaultForm,
      },
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
      ],
      loading: false,
      loadingBtn: false,
    };
  },
  methods: {
    isInt,
    onChangeAddAttendanceSheet(checked) {
      if (checked) {
        this.$set(this.form, "addAttendanceSheet", true);
      } else {
        this.$set(this.form, "addAttendanceSheet", false);
      }
    },
    onChangeAllowReplaceLeaveOnHoliday(checked) {
      if (checked) {
        this.$set(this.form, "allowReplaceLeaveOnHoliday", true);
      } else {
        this.$set(this.form, "allowReplaceLeaveOnHoliday", false);
      }
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.onUpdatedTypeWorkLeave();
        } else {
          return false;
        }
      });
    },
    onUpdatedTypeWorkLeave() {
      this.loadingBtn = true;
      this.$apollo
        .mutate({
          mutation: query.updateTypeWorkLeave,
          variables: {
            ...this.form,
            limit: +this.form?.limit > 0 ? +this.form.limit : null,
          },
        })
        .then(({ data }) => {
          this.$notification.success({
            message: "Success",
            description: "Updated Success!",
          });
          this.loadingBtn = false;
          if (data?.updateTypeWorkLeave?.id) {
            this.refreshAfterUpdated(data.updateTypeWorkLeave);
          }

          this.close();
        })
        .catch((err) => {
          this.loadingBtn = false;
          this.$notification.error({
            message: "Error",
            description: "Updated Error!",
          });
          console.log("Cập nhật loại nghỉ phép không thành công", err);
        });
    },
    onGetTypeWorkLeave() {
      this.loading = true;
      this.$apollo
        .query({
          fetchPolicy: "no-cache",
          query: query.getTypeWorkLeave,
          variables: { id: this.idTypeWorkLeave },
        })
        .then(({ data }) => {
          this.loading = false;
          if (data?.getTypeWorkLeave?.id) {
            this.typeWorkLeave = { ...data.getTypeWorkLeave };
            this.form = { ...data.getTypeWorkLeave };

            if (this.form.addAttendanceSheet) {
              this.checkAddAttendanceSheet = true;
            } else {
              this.checkAddAttendanceSheet = false;
            }
          }
        })
        .catch((err) => {
          this.$notification.error({
            message: "Error",
            description: "Updated Error!",
          });
          console.log("Lấy chi tiết loại nghỉ phép không thành công", err);
        });
    },
    onDeletedTypeWorkLeave() {
      if (this?.form?.id) {
        this.loadingBtn = true;
        this.$apollo
          .mutate({
            mutation: query.deleteTypeWorkLeave,
            variables: {
              id: this.form.id,
            },
          })
          .then(({ data }) => {
            this.$notification.success({
              message: "Success",
              description: "Deleted Success!",
            });
            this.loadingBtn = false;
            if (data?.deleteTypeWorkLeave?.id) {
              this.refreshAfterDeleted(data.deleteTypeWorkLeave);
            }

            this.close();
          })
          .catch((err) => {
            this.loadingBtn = false;
            this.$notification.error({
              message: "Error",
              description: "Deleted Error!",
            });
            console.log("Xóa loại nghỉ phép không thành công", err);
          });
      }
    },
  },
  created() {
    this.onGetTypeWorkLeave();
  },
};
</script>
<style scoped>
.ict24h-editor >>> .ql-toolbar.ql-snow {
  padding: 2px !important;
}
</style>
